import type { LocaleMessages } from '../types';
import { helpMessages } from './help.en';

/**
 * English strings. Every user-facing string in the SPA must have
 * a key here. To add a new locale, copy this file to
 * `<locale>.ts` and translate each message — the registry falls
 * back to `en` for missing keys (and reports a metric) so adding
 * a locale is non-breaking.
 *
 * Naming: `<screen>.<element>` for screen-local strings,
 * `<common>.<element>` for cross-screen vocabulary.
 */
export const en: LocaleMessages = {
  locale: 'en',
  displayName: 'English',
  messages: {
    'common.appName': 'Nexsoss',
    'common.signIn': 'Sign in',
    'common.signOut': 'Sign out',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.loading': 'Loading…',
    'common.error': 'Something went wrong',
    'common.retry': 'Retry',

    'nav.overview': 'Overview',
    'nav.fleet': 'Robots',
    'nav.devices': 'Devices',
    'nav.alerts': 'Alerts',
    'nav.tasks': 'Tasks',
    'nav.metrics': 'Metrics',
    'nav.access': 'Access',
    'nav.audit': 'Audit',
    'nav.profile': 'Profile',

    'overview.title': 'Operations Overview',
    'overview.activeRobots': 'Robots Online (%{site})',
    'overview.activeTasks': 'Active Tasks (%{site})',
    'overview.openAlerts': 'Open Alerts (%{site})',
    'overview.fireAlarm': 'Fire Alarm',
    'overview.fireAlarmClear': 'Clear',
    'overview.fireAlarmTriggered': 'TRIGGERED',

    'tasks.title': 'Tasks — %{site}',
    'tasks.newTask': '+ New task',
    'tasks.dispatch': 'Dispatch',
    'tasks.tableView': 'Table',
    'tasks.calendarView': 'Calendar',

    'fleet.title': 'Robots',
    'fleet.filterAll': 'All',
    'fleet.filterGausium': 'Gausium',
    'fleet.filterActive': 'Active',
    'fleet.filterOffline': 'Offline',

    'map.title': 'Building Map',
    'map.robotsCount': '%{count} robots',
    'map.doorsCount': '%{count} doors',
    'map.liftsCount': '%{count} lifts',

    'alerts.title': 'Alerts',
    'alerts.empty': 'No alerts to show.',

    'devices.title': 'Devices',
    'devices.tab.doors': 'Doors',
    'devices.tab.lifts': 'Lifts',
    'devices.tab.systems': 'Systems',

    'access.title': 'Access',
    'access.displayName': 'Display Name',
    'access.email': 'Email',
    'access.organisation': 'Organisation',
    'access.client': 'Client',
    'access.roles': 'Roles',
    'access.noRole': 'No role assigned',

    'audit.title': 'Audit',
    'audit.exportCsv': 'Export CSV',
    'audit.fromDate': 'From date',
    'audit.empty': 'No audit events',
    'audit.col.timestamp': 'Timestamp',
    'audit.col.actor': 'Actor',
    'audit.col.action': 'Action',
    'audit.col.resource': 'Resource',
    'audit.col.result': 'Result',

    'avatar.preferences': 'Preferences',
    'avatar.accountMenu': 'Account menu for %{name}',
    'avatar.signedOut': 'Signed out',

    'hotkey.gPrefix': 'then',
    'hotkey.gHelp': 'Press g then a letter to jump: g o overview · g f fleet · g m map · g t tasks · g a alerts · g d devices · g p profile',

    // Help mode's strings are GENERATED from `docs/help-copy/*.md`,
    // which is where they are edited and reviewed. They are the only
    // strings in this app a hotel manager has to be able to read and
    // correct, and a 900-line TypeScript object is not somewhere they
    // will ever find them. `pnpm help:gen` rewrites `help.en.ts`, and a
    // test fails the build if the two ever disagree.
    ...helpMessages,

  },
};
